import {RefObject} from 'react';

import {ReactGoogleAutocompleteProps, usePlacesWidget} from 'react-google-autocomplete';

export type GoogleAutocompleteCallbackType = (
    places: google.maps.places.PlaceResult,
    ref: RefObject<HTMLInputElement>,
    autocomplete: google.maps.places.Autocomplete,
) => void;
/**
 * hook for google autocomplete
 */
export const useGooglePlacesWidget = ({
    country,
    inputAutocompleteValue,
    onAutocomplete,
}: {
    onAutocomplete: GoogleAutocompleteCallbackType;
    inputAutocompleteValue: ReactGoogleAutocompleteProps['inputAutocompleteValue'];
    country: string | string[];
}) => {
    return usePlacesWidget({
        apiKey: process.env.GOOGLE_API_KEY,
        inputAutocompleteValue,
        language: 'en',
        libraries: ['places'],
        // @ts-expect-error incorrect type from react-google-autocomplete, the autocomplete is not ref
        onPlaceSelected: onAutocomplete,
        options: {
            componentRestrictions: {country: country || []},
            fields: ['ALL'],
            types: ['geocode'],
        },
    });
};
